import script from "./ReceitasManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasManager.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasManager.vue?vue&type=style&index=0&id=01134c3a&lang=css"

const __exports__ = script;

export default __exports__